import React from "react";
import _ from "lodash";

import Text from "src/components/text";
import { formatTimespent, getAuthorName } from "src/services/reports.service";

import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

import styles from "./styles.module.scss";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface TopEngagedAssetListCardProps {
  item: {
    asset: Asset;
    analytics: Analytics;
    reactions: number;
    comments: number;
  };
  columnCount: number;
}

export const TopEngagedAssetListCard: React.FC<TopEngagedAssetListCardProps> = ({
  item,
  columnCount,
}) => {
  const { asset, analytics, reactions, comments } = item;

  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={asset?.icon?.thumbnail || DefaultAssetIcon}
          alt={asset.name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/assets/${asset.id}?source=reports`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text lines={1} className={styles.title} text={asset?.name} />
            </div>
            <div className={styles.metaData}>
              Author:{" "}
              <Text
                text={asset.author ? getAuthorName(asset.author) : ""}
                lines={1}
                className={styles.author}
              />
            </div>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{reactions}</div>
        <div className={styles.tableDataViews}>{comments}</div>
        <div className={styles.tableDataTime}>{formatTimespent(analytics.avgTimeSpent || 0)}</div>
        <div className={styles.tableDataTime}>{formatTimespent(analytics.totalTimeSpent || 0)}</div>
        <div className={styles.tableDataViews}>{analytics.views}</div>
      </div>
    </div>
  );
};
